import React from 'react'
import Text from '../../atoms/Text'
import { formatCurrency } from '../../../utils/helpers/common'
import { ReactComponent as Test } from '../../../assets/icons/test-flask.svg'

const CKDTestList = () => {
  return (
    <div className="flex flex-col gap-4 px-4 py-1">
      <div className="w-full flex flex-row items-center justify-between">
        <Text
          tag={'p'}
          variant={'title'}
          size={'medium'}
          className={'text-text-primary'}
        >
          Tests
        </Text>
      </div>
      <div className="bg-WHITE p-4 rounded-4 flex flex-col gap-4">
        <div className="flex flex-row items-center gap-3 justify-between pb-4 border-b border-b-border-secondary">
          <Test className="min-h-6 min-w-6" />
          <Text
            tag={'p'}
            variant={'title'}
            size={'small'}
            className={'text-text-primary w-full'}
          >
            eGFR
          </Text>
          <Text
            tag={'p'}
            variant={'label'}
            size={'medium'}
            className={'text-text-quartenary'}
          >
            {formatCurrency(249)}
          </Text>
        </div>
        <div className="flex flex-row items-center gap-3 justify-between">
          <Test className="min-h-6 min-w-6" />
          <Text
            tag={'p'}
            variant={'title'}
            size={'small'}
            className={'text-text-primary w-full'}
          >
            Albuminuria
          </Text>
          <Text
            tag={'p'}
            variant={'label'}
            size={'medium'}
            className={'text-text-quartenary'}
          >
            {formatCurrency(750)}
          </Text>
        </div>
      </div>
    </div>
  )
}

export default CKDTestList
